import React from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { onClickImportType, exportRecipes } from 'actions/ingredients/recipes';
import Upload from './UploadRecipe/Upload';
import DownloadTemplate from './DownloadTemplate/DownloadTemplate';
import ImportType from './ImportType/ImportType';
import ResponseImportRecipes from './ResponseImportRecipes/ResponseImportRecipes';

class MasterForm extends React.Component {
  _handleChangeImportType = val => {
    const { dispatch } = this.props;
    dispatch(onClickImportType(val));
  };

  _handleDownload = task => {
    const { dispatch, search } = this.props;
    const prefix = 'Recipes - ';
    dispatch(
      exportRecipes(
        {
          keyword: '',
          outletName: search.outletName,
          email: search.email,
          is_export_template: true,
          export_task: task,
        },
        prefix,
        search.outletIds[0]
      )
    );
  };

  render() {
    const {
      createRecipesForm: {
        step,
        importType,
        messages,
        isError,
        stepFirstTimeUserExperience,
      },
      loadingSpinner,
      email,
      dispatch,
    } = this.props;
    return (
      <div>
        {/*  render the form steps and pass required props in */}
        <DownloadTemplate
          currentStep={step}
          handleDownload={this._handleDownload}
          showLoadingSpinner={loadingSpinner}
          email={email}
          dispatch={dispatch}
          stepFirstTimeUserExperience={stepFirstTimeUserExperience}
        />
        <ImportType
          currentStep={step}
          handleChange={this._handleChangeImportType}
          checked={importType}
        />
        <Upload currentStep={step} />
        <ResponseImportRecipes
          currentStep={step}
          messages={messages}
          isError={isError}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.ingredients.recipes,
    businessId: state.moka.user.business.id,
    email: state.moka.user.email,
    loadingSpinner: state.moka.showLoadingSpinner,
    search: getFormValues('search')(state),
  };
}

export default connect(mapStateToProps)(MasterForm);
